<template>
  <v-dialog scrollable v-model="value" max-width="800">
    <v-card>
      <v-card-title class="subtitle-1">
        <v-icon color="black" class="mr-2" size="20">mdi-plus-circle</v-icon>
        {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.TITLE") }}
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="grey lighten-2 pt-5">
        <v-text-field
          prepend-inner-icon="mdi-arrow-right-thick"
          solo
          :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.QUALIFICATION_NAME_LABEL')"
          hide-details
          class="mb-3"
          v-model="data.name"
        ></v-text-field>
        <v-card>
          <v-card-text class="d-flex align-center">
            <div class="mr-1">
              <v-icon>mdi-arrow-right-thick</v-icon>
            </div>
            <div>
              <v-chip color="grey darken-3" dark label class="mr-1 mb-1 pr-2" :key="key" v-for="(item, key) in itemValue">
                {{ item.name }}
                <v-btn x-small icon class="ml-3" @click="editItemOpen(item.code)">
                  <v-icon size="15">mdi-pencil</v-icon>
                </v-btn>
                <v-btn x-small icon @click="removeItemOpen(item.code)">
                  <v-icon size="15">mdi-delete</v-icon>
                </v-btn>
              </v-chip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-on="on" v-bind="attrs" color="grey darken-3" dark label class="mr-1 mb-1 px-3" @click="addItemOpen">
                    <v-icon size="17">mdi-plus-circle</v-icon>
                  </v-chip>
                </template>
                <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.SET_VALUE_BTN") }}</span>
              </v-tooltip>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark small color="success" class="px-3" @click="nitelikGuncelle" :loading="loading">
          <v-icon size="18" class="mr-1">mdi-plus-circle</v-icon>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.UPDATE_BTN") }}
        </v-btn>
        <v-btn dark color="red darken-2" small @click="$emit('input', false)">
          <v-icon class="mr-1" size="18">mdi-close</v-icon>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.CLOSE_BTN") }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Add Item -->
    <v-dialog v-model="addItemDialog" max-width="500">
      <v-text-field
        ref="addItemText"
        :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.ADD_ITEM_SET_VALUE_LABEL')"
        v-model="addField"
        solo
        dense
        hide-details
      >
        <template #append>
          <v-tooltip bottom color="info">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="info" class="mr-2" fab x-small :loading="addLoading" @click="addItem">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.ADD_ITEM_SET_BTN") }}</span>
          </v-tooltip>
          <v-tooltip bottom color="error">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="addItemDialog = false">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.ADD_ITEM_CANCEL_BTN") }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </v-dialog>
    <!-- ./Add Item -->

    <!-- Edit Item -->
    <v-dialog v-model="editItemDialog" max-width="500">
      <v-text-field
        :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.EDIT_ITEM_SET_VALUE_LABEL')"
        v-model="editField.name"
        solo
        dense
        hide-details
      >
        <template #append>
          <v-tooltip bottom color="success">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="success" class="mr-2" fab x-small @click="editItem">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.EDIT_ITEM_SAVE_BTN") }}</span>
          </v-tooltip>
          <v-tooltip bottom color="error">
            <template #activator="{on, attrs}">
              <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="editItemDialog = false">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.EDIT_ITEM_CANCEL_BTN") }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </v-dialog>
    <!-- ./Edit Item -->

    <!-- Remove Item -->
    <v-dialog v-model="removeItemDialog" max-width="500">
      <v-card>
        <div class="d-flex justify-space-between align-center px-3 py-2">
          <div class="text-subtitle-2">
            <v-icon left color="red darken-2">mdi-alert</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.REMOVE_ITEM_TITLE") }}
          </div>
          <div>
            <v-tooltip bottom color="info">
              <template #activator="{on, attrs}">
                <v-btn v-on="on" v-bind="attrs" color="info" class="mr-2" fab x-small @click="removeItem" :loading="removeItemLoading">
                  <v-icon>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.REMOVE_ITEM_REMOVE_BTN") }}</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template #activator="{on, attrs}">
                <v-btn v-on="on" v-bind="attrs" color="error" fab x-small @click="removeItemDialog = false">
                  <v-icon>mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_QUALIFICATIONS_AREA.EDIT_QUALIFICATION_DIALOG.REMOVE_ITEM_CANCEL_BTN") }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- ./Remove Item -->
  </v-dialog>
</template>

<script>
import UrunlerService from "@/services/UrunlerService.js";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    }
  },
  name: "UrunNitelikDuzenle",
  data: () => ({
    editField: {},
    addField: "",
    editItemDialog: false,
    loading: false,
    addItemDialog: false,
    addLoading: false,
    removeItemDialog: false,
    removeField: "",
    removeItemLoading: false
  }),
  computed: {
    /**
     * @returns {Object}
     */
    item() {
      return this.data;
    },
    /**
     * @returns {String}
     */
    itemName() {
      return this.data.name;
    },
    /**
     * @returns {String}
     */
    itemCode() {
      return this.data.code;
    },
    /**
     * @returns {Array}
     */
    itemValue() {
      return this.data.value;
    }
  },
  methods: {
    editItemOpen(itemCode) {
      this.editField = JSON.parse(JSON.stringify(this.itemValue.find(o => o.code === itemCode)));
      this.editItemDialog = true;
    },
    editItem() {
      let newItems = this.data.value.map(o => {
        if (this.editField.code == o.code) {
          o.name = this.editField.name;
          return o;
        } else {
          return o;
        }
      });

      this.$set(this.data, "value", newItems);

      this.editItemDialog = false;
    },
    addItem() {
      const nitelikCode = this.itemCode,
        nitelikDegeri = this.addField;
      this.addLoading = true;
      UrunlerService.nitelikDegeriEkle({ nitelikCode, nitelikDegeri })
        .then(res => {
          if (res.status === 200) {
            this.addItemDialog = false;
            this.$emit("changed");
            this.data.value.push(res.data);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.addLoading = false;
        });
    },
    addItemOpen() {
      this.addItemDialog = true;
      // this.$refs.addItemText.$el.focus();
    },
    addItemDialogInput() {
      console.log(this.$refs.addItemText);
    },
    removeItem() {
      const nitelikCode = this.itemCode,
        nitelikDegerCode = this.removeField;
      this.removeItemLoading = true;
      UrunlerService.nitelikDegeriKaldir({ nitelikCode, nitelikDegerCode })
        .then(res => {
          if (res.status === 200) {
            this.removeItemDialog = false;
            this.$emit("changed");
            this.data.value = this.itemValue.filter(x => x.code !== nitelikDegerCode);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.removeItemLoading = false;
        });
    },
    removeItemOpen(itemCode) {
      this.removeItemDialog = true;
      this.removeField = itemCode;
    },
    delItem(key) {
      let list = [];
      this.value.forEach((d, k) => {
        if (k !== key) list.push(d);
      });
      this.combobox = list;
    },
    isEditing(key) {
      return this.comboboxEditKey === key;
    },
    nitelikGuncelle() {
      let nitelikCode = this.itemCode,
        nitelikAdi = this.itemName,
        nitelikler = this.itemValue;
      this.loading = true;
      UrunlerService.nitelikGuncelle({ nitelikCode, nitelikAdi, nitelikler })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_QUALIFICATIONS.QUALIFICATION_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.$emit("input", false);
            this.$emit("changed");
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
